/**
 * Disciplines Store
 * Manages disciplines data for filters
 */

import { create } from 'zustand';
import { fetchDisciplines } from '../services/disciplines.service';
import type { Discipline } from '../interfaces/apiInterfaces/disciplines';

interface DisciplinesStore {
  disciplines: Discipline[];
  isLoading: boolean;
  error: string | null;
  load: () => Promise<void>;
  reset: () => void;
}

export const useDisciplinesStore = create<DisciplinesStore>((set) => ({
  disciplines: [],
  isLoading: false,
  error: null,

  load: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await fetchDisciplines({
        page_number: 1,
        page_size: 200, // API max for dropdown
      });
      set({ disciplines: response.data, isLoading: false });
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to load disciplines';
      set({ error: message, isLoading: false });
      console.error('Failed to load disciplines:', error);
    }
  },

  reset: () => set({ disciplines: [], isLoading: false, error: null }),
}));
